import { PORTFOLIO_INSTRUMENT_KIND_OBJ, OPTION_RIGHT_LABELS, SECURITY_TYPE_OBJ, SECURITY_TYPE_LABELS, getPortfolioPositionKey, type OptionContract, type PortfolioInstrumentRef } from "@signals/shared";

export interface PortfolioInstrumentDescriptor {
  instrument?: PortfolioInstrumentRef;
  optionContractId?: string | null;
  optionContract?: OptionContract | null;
  instrumentName?: string | null;
  symbolId?: string | null;
  symbolTicker?: string | null;
  symbolName?: string | null;
  accountId?: string | null;
  canonicalType?: string | null;
}

export function getPositionInstrument(row: PortfolioInstrumentDescriptor): PortfolioInstrumentRef | null {
  if (row.instrument) return row.instrument;
  if (row.optionContractId && !row.symbolId) return { kind: PORTFOLIO_INSTRUMENT_KIND_OBJ.OPTION, optionContractId: row.optionContractId };
  if (row.symbolId && !row.optionContractId) return { kind: PORTFOLIO_INSTRUMENT_KIND_OBJ.SECURITY, symbolId: row.symbolId };
  return null;
}

export function isOptionPosition(row: PortfolioInstrumentDescriptor): boolean {
  return row.instrument?.kind === PORTFOLIO_INSTRUMENT_KIND_OBJ.OPTION || Boolean(row.optionContractId);
}

export function getPositionRowKey(row: PortfolioInstrumentDescriptor): string {
  const instrument = getPositionInstrument(row);
  return instrument ? getPortfolioPositionKey({ accountId: row.accountId ?? "", ...instrument })
    : JSON.stringify([row.accountId ?? null, row.symbolTicker ?? null, row.symbolName ?? null]);
}

/** Human labels never participate in identity, matching or financial calculations. */
export function formatPortfolioInstrumentName(row: PortfolioInstrumentDescriptor): string {
  const contract = row.optionContract;
  if (isOptionPosition(row)) return contract
    ? `${contract.underlyingName} ${OPTION_RIGHT_LABELS[contract.right]?.["en-US"] ?? contract.right} ${contract.strike} ${contract.premiumCurrency} · ${contract.expiry}`
    : row.instrumentName ?? "Опционный контракт";
  const name = row.symbolTicker ?? row.symbolName ?? row.instrumentName ?? "—";
  return row.canonicalType === SECURITY_TYPE_OBJ.WARRANT ? `${SECURITY_TYPE_LABELS[SECURITY_TYPE_OBJ.WARRANT]["ru-RU"]} · ${name}` : name;
}

export function isReadOnlyPortfolioInstrument(row: PortfolioInstrumentDescriptor & { readOnly?: boolean }): boolean {
  return row.readOnly === true || isOptionPosition(row);
}
